import axios from 'axios';
import Cookies from 'js-cookie';

const instance = axios.create({
  baseURL: 'https://xadom-account-backend.onrender.com',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 로그인 팝업이 이미 열려있는지 확인하는 플래그
let isLoginPopupOpen = false;
let loginPopupWindow: Window | null = null;

// 요청 인터셉터
instance.interceptors.request.use(
  config => {
    // print API 호출 시에는 토큰 제외
    if (config.url?.includes('http://127.0.0.1:5050/print')) {
      return config;
    }
    
    const token = Cookies.get('AUTH_TOKEN');
    if (token) {               
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 응답 인터셉터
instance.interceptors.response.use(
  response => response,
  error => {
    // 401 Unauthorized 또는 "login required" 응답 처리
    const isLoginRequired = 
      error.response?.status === 401 || 
      error.response?.data?.message?.toLowerCase().includes('login required') ||
      error.response?.data?.error?.toLowerCase().includes('login required') ||
      (typeof error.response?.data === 'string' && error.response.data.toLowerCase().includes('login required'));

    if (isLoginRequired) {
      Cookies.remove('AUTH_TOKEN');
      
      // 이미 로그인 팝업이 열려있지 않은 경우에만 새 팝업 열기
      if (!isLoginPopupOpen || !loginPopupWindow || loginPopupWindow.closed) {
        isLoginPopupOpen = true;
        
        const popupWidth = 500;
        const popupHeight = 600;
        
        // 현재 브라우저 창 기준으로 중앙 계산 (듀얼모니터 대응)
        const currentWindowLeft = window.screenX || window.screenLeft || 0;
        const currentWindowTop = window.screenY || window.screenTop || 0;
        const currentWindowWidth = window.outerWidth;
        const currentWindowHeight = window.outerHeight;
        
        const leftPosition = currentWindowLeft + Math.round((currentWindowWidth - popupWidth) / 2);
        const topPosition = currentWindowTop + Math.round((currentWindowHeight - popupHeight) / 2);
        
        const popupOptions = [
          `width=${popupWidth}`,
          `height=${popupHeight}`,
          'scrollbars=yes',
          'resizable=yes',
          'toolbar=no',
          'menubar=no',
          'location=no',
          'directories=no',
          'status=no',
          `left=${leftPosition}`,
          `top=${topPosition}`
        ].join(',');
        
        // 로그인 팝업 열기 (popup 파라미터 추가)
        loginPopupWindow = window.open(
          'https://www.xadom.ai/login?popup=true',
          'loginPopup',
          popupOptions
        );
        
        // postMessage 리스너 추가
        const handleMessage = (event: MessageEvent) => {
          // 보안을 위해 origin 체크
          if (event.origin !== 'https://www.xadom.ai') return;
          
          if (event.data.type === 'LOGIN_SUCCESS') {
            console.log('로그인 성공! 팝업을 닫습니다.');
            
            // 팝업 닫기
            loginPopupWindow?.close();
            clearInterval(checkLoginStatus);
            isLoginPopupOpen = false;
            loginPopupWindow = null;
            
            // 토큰이 있다면 저장
            if (event.data.token) {
              Cookies.set('AUTH_TOKEN', event.data.token);
            }
            
            // 이벤트 리스너 정리
            window.removeEventListener('message', handleMessage);
            
            // 페이지 새로고침 (필요에 따라 수정)
            window.location.reload();
          }
        };
        
        window.addEventListener('message', handleMessage);
        
        // 팝업 상태 모니터링 (postMessage 방식으로 수정)
        const checkLoginStatus = setInterval(() => {
          try {
            // 팝업이 닫혔는지 확인
            if (loginPopupWindow?.closed) {
              clearInterval(checkLoginStatus);
              window.removeEventListener('message', handleMessage);
              isLoginPopupOpen = false;
              loginPopupWindow = null;
              return;
            }

            // 기존 JSESSION 토큰 체크도 유지 (백업용)
            const token = Cookies.get('JSESSIONID');
            if (token) {
              console.log('JSESSION 토큰 발견! 팝업을 닫습니다.');
              
              loginPopupWindow?.close();
              clearInterval(checkLoginStatus);
              window.removeEventListener('message', handleMessage);
              isLoginPopupOpen = false;
              loginPopupWindow = null;
            }
          } catch (e) {
            console.log('체크 에러:', e);
            clearInterval(checkLoginStatus);
            window.removeEventListener('message', handleMessage);
          }
        }, 1000);
      } else {
        // 이미 열린 팝업에 포커스
        loginPopupWindow.focus();
      }
    }
    
    return Promise.reject(error);
  }
);

export default instance; 
